
    import {Component, Vue} from 'vue-property-decorator'

    @Component
    export default class ShareLogin extends Vue {
        formData : {
            userName:'用户名'
        }

        loginClick() {
            this.$router.back();
        }
    }
